import React, { Component } from 'react'
import { Grid, Button, Tooltip } from '@material-ui/core'
import Send from '@material-ui/icons/Send'
import ThumbUp from '@material-ui/icons/ThumbUp'
import ThumbDown from '@material-ui/icons/ThumbDown'
import Cancel from '@material-ui/icons/Cancel'
import Delete from '@material-ui/icons/Delete'
import Save from '@material-ui/icons/Save'
import LoadingButton from '../LoadingButton'
import ReceiveLineItems from './LineItems/ReceiveLineItems';
import Modal from '../../elements/Modal/Modal'
import UpdatePurchaseOrderStatus from './UpdatePurchaseOrderStatus';
import SubmitModal from './SubmitModal';
import ApproveModal from './ApproveModal';
import { red } from '../Colors';

import * as defs from './PurchaseOrder.module.scss';

export default class PurchaseOrderActions extends Component {

  constructor(props) {
    super(props)
    this.newSubmit = this.newSubmit.bind(this);
    this.newApprove = this.newApprove.bind(this);
    this.newReceive = this.newReceive.bind(this);
    this.newReject = this.newReject.bind(this);
    this.newCancel = this.newCancel.bind(this);
    this.newResubmit = this.newResubmit.bind(this);
    this.handleReceive = this.handleReceive.bind(this);
    this.closeModalReceive = this.closeModalReceive.bind(this);
    this.closeModalApprove = this.closeModalApprove.bind(this);
    this.closeModalSubmit = this.closeModalSubmit.bind(this);
    this.closeModalChangeStatus = this.closeModalChangeStatus.bind(this);
    this.state = {
      showModalReceive: false,
      showModalChangeStatus: false,
      showModalSubmit: false,
      showModalApprove: false,
    }
  }

  // Submit
  newSubmit() {
    if (this.props.validationErrors()) return false;
    this.setState({showModalSubmit: true })
  }

  closeModalSubmit() {
    this.setState({showModalSubmit: false })
  }

  // Approve
  newApprove() {
    this.setState({showModalApprove: true })
  }

  closeModalApprove() {
    this.setState({showModalApprove: false })
  }

  // Receive
  newReceive() {
    this.setState({showModalReceive: true })
  }
  
  closeModalReceive() {
    this.setState({showModalReceive: false })
  }

  // Reject/re-submit/cancel
  newReject() {
    this.setState({showModalChangeStatus: true, newStatus: 'rejected' })
  }

  newResubmit() {
    this.setState({showModalChangeStatus: true, newStatus: 'pending' })
  }

  newCancel() {
    this.setState({showModalChangeStatus: true, newStatus: 'canceled' })
  }
  
  closeModalChangeStatus() {
    this.setState({showModalChangeStatus: false, newStatus: null })
  }

  handleReceive(lineItems, res) {
    this.props.onUpdate(lineItems);
    this.props.onStatusChange(res);
  }

  render() {

    const {
      purchaseOrder,
      user,
      isEditing,
      isEditingLineItems,
      isSaving,
      onApprove = null,
      onStartEdit = null,
      onCancelEdit = null,
      onSubmit = null,
      onStatusChange = null,
      onClose = null,
      onDelete = null,
    } = this.props;

    const { showModalApprove, showModalReceive, showModalChangeStatus, showModalSubmit, newStatus } = this.state;

    return (
      <>
        <Modal show={showModalReceive} onClose={this.closeModalReceive}>
          <ReceiveLineItems lineItems={purchaseOrder.lineItems} onClose={this.closeModalReceive} onReceive={this.handleReceive} />
        </Modal>

        <Modal show={showModalChangeStatus} onClose={this.closeModalChangeStatus}>
          <UpdatePurchaseOrderStatus status={newStatus} purchaseOrder={purchaseOrder} onClose={this.closeModalChangeStatus} onStatusChange={onStatusChange} />
        </Modal>

        <Modal show={showModalSubmit} onClose={this.closeModalSubmit}>
          <SubmitModal purchaseOrder={purchaseOrder} onSubmit={onSubmit} />
        </Modal>

        <Modal show={showModalApprove} onClose={this.closeModalApprove}>
          <ApproveModal purchaseOrder={purchaseOrder} onApprove={onApprove} onClose={this.closeModalApprove} />
        </Modal>

        <Grid xs={12} md={12} style={{ margin: 16 }} item>
          { purchaseOrder.status === 'unsaved' &&
            <LoadingButton
              style={{marginRight: '13px'}}
              color="primary"
              variant="contained"
              disabled={isEditingLineItems}
              onClick={this.newSubmit}
              loading={isSaving}
            >
              <Send style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
              Submit for approval
            </LoadingButton>
          }
          { ['admin', 'depotManager'].includes(user.type) && purchaseOrder.status === 'pending' && !isEditing &&
            <LoadingButton
              style={{marginRight: '13px', minWidth: '140px'}}
              color="primary"
              loading={isSaving}
              variant="contained"
              onClick={this.newApprove}
            >
              <ThumbUp style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
              Approve
            </LoadingButton>
          }
          { ['admin'].includes(user.type) && purchaseOrder.status === 'received' && !isEditing &&
            <LoadingButton
              style={{marginRight: '13px', minWidth: '140px'}}
              color="primary"
              loading={isSaving}
              variant="contained"
              onClick={onClose}
            >Close</LoadingButton>
          }
          { ['approved', 'received'].includes(purchaseOrder.status) && !isEditing &&
            <Button
              style={{marginRight: '13px'}}
              color="primary"
              variant="outlined"
              onClick={this.newReceive}
            >Receive items...</Button>
          }
          { purchaseOrder.status === 'rejected' && !isEditing &&
            <Button
              style={{marginRight: '13px'}}
              color="primary"
              variant="outlined"
              onClick={this.newResubmit}
            >Re-submit for approval...</Button>
          }
          { (['pending', 'rejected', 'approved', 'received'].includes(purchaseOrder.status) && !isEditing) &&
            <Button
              style={{marginRight: '13px', minWidth: '120px'}}
              color="primary"
              variant="outlined"
              onClick={onStartEdit}
            >Edit</Button>
          }
          <div className={defs.negativeActionsContainer}>
            { ['admin', 'depotManager'].includes(user.type) && ['pending', 'approved'].includes(purchaseOrder.status) && !isEditing &&
              <Button
                style={{marginRight: '13px', minWidth: '120px', borderColor: red, color: red}}
                variant="outlined"
                onClick={this.newReject}
              >
                <ThumbDown style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
                Reject...
              </Button>
            }
            { ['approved', 'received', 'rejected'].includes(purchaseOrder.status) && !isEditing && user.type === 'admin' &&
              <Button
                style={{marginRight: '13px', minWidth: '120px', borderColor: red, color: red}}
                color="primary"
                variant="outlined"
                onClick={this.newCancel}
              >
                <Cancel style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
                Cancel...
              </Button>
            }
            { (['pending', 'rejected', 'approved'].includes(purchaseOrder.status) && !isEditing) &&
              <>
                { purchaseOrder.purchaseOrderNumber && <>
                  <Tooltip title="PO number already issued. Admin user can cancel instead.">
                    <span style={{display: 'inline-block'}}>
                      <Button
                        style={{marginRight: '13px', minWidth: '120px'}}
                        variant="outlined"
                        disabled={true}
                      >
                        <Delete style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
                        Delete
                      </Button>
                    </span>
                  </Tooltip>
                </>}
                { !purchaseOrder.purchaseOrderNumber && <>
                  <Button
                    style={{marginRight: '13px', minWidth: '120px', borderColor: red, color: red}}
                    variant="outlined"
                    onClick={onDelete}
                  >
                    <Delete style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
                    Delete
                  </Button>
                </>}
              </>
            }
          </div>
          { (purchaseOrder.status !== 'unsaved' && isEditing) &&
            <>
              <LoadingButton
                style={{marginRight: '13px'}}
                color="primary"
                variant="contained"
                disabled={isEditingLineItems}
                loading={isSaving}
                onClick={() => onSubmit() } // Don't send event
              >
                <Save style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
                Save changes
              </LoadingButton>
              <Button
                style={{marginRight: '13px'}}
                variant="outlined"
                onClick={onCancelEdit}
              >Cancel</Button>
            </>
          }
        </Grid>
      </>
    )
  }
}